<template>
    <div>
      <CRow class="mb-3 search-panel">
        <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
          <label>Thao tác</label>
          <div class="dropdown btn-group" style="height: 36px;">
            <button class="btn">
              <div class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="actionData.model.selectedAll"
                    @change="changeSelectAll" id="selectedAll" />
                  <label class="custom-control-label" for="selectedAll"></label>
                </div>
              </div>
            </button>
            <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
              aria-expanded="false" aria-haspopup="true"></button>
            <div class="dropdown-menu">
              <button :disabled="actionData.model.listSelectedId.length === 0" class="dropdown-item"
                @click="setupSelectOneAction('delete_list')" color="danger">
                <CIcon name="cil-trash" style="danger" class="mr-2" />
                Xóa tất cả
              </button>
            </div>
          </div>
        </CCol>
        <CCol sm="2" xs="12">
          <BaseInput :options="documentNoInput.options" :data="documentNoInput.data" :listener="documentNoInput.listener" />
        </CCol>
        <CCol sm="2" xs="12">
          <BaseInput :options="descriptionInput.options" :data="descriptionInput.data" :listener="descriptionInput.listener" />
        </CCol>
        <CCol sm="2" xs="12">
          <BaseSelect :options="inventoryTypeSelect.options" :data="inventoryTypeSelect.data" />
        </CCol>
        <CCol sm="2" xs="12">
          <BaseSelect :options="customerSelect.options" :data="customerSelect.data" />
        </CCol>
        <CCol>
          <div class="form-group">
            <label style="color: white"></label>
            <div style="margin-top: 10px">
              <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
                class="btn-action-primary" @click="loadDataMainTable(true)">
                <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
              </CButton>
              <CButton style="float: right;" color="primary" v-c-tooltip.hover="'Tạo mới'" class="btn-action-primary"
                @click="$router.push('/stock-management/create.html')">
                <i class="fa fa-plus"></i>&nbsp;Tạo mới
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
            @row-click="rowClickTable($event)" ref="mainTable">
            <template #checkbox="{ item }">
              <td class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="actionData.model.listSelectedId"
                    :value="item.id" :id="item.id" v-c-tooltip.hover="'Selected'" />
                  <label class="custom-control-label" :for="item.id"></label>
                </div>
              </td>
            </template>
            <template #warehouse="{ item }">
              <td>
                {{ item.warehouseCode }} - {{ item.warehouseName }}
              </td>
            </template>
            <template #createDate="{ item }">
              <td>
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
            </template>

            <template #inventoryDate="{ item }">
              <td>
                {{ $helper.formatDateDDMMYYYY(item.inventoryDate) }}
              </td>
            </template>
            <template #accountingDate="{ item }">
              <td>
                {{ $helper.formatDateDDMMYYYYHHMM(item.accountingDate) }}
              </td>
            </template>
            <template #inventoryType="{ item }">
              <td>
                <span v-if="item.inventoryType == 'in'">
                    Nhập kho
                </span>
                <span v-if="item.inventoryType == 'out'">
                  Xuất kho
                </span>
              </td>
            </template>
            <template #purpose="{ item }">
              <td>
                <CBadge v-if="item.purpose == 'new'" color="info" class="mr-1">
                  {{ $helper.stockPurposeLabel(item.inventoryType, item.purpose) }}
                </CBadge>
                <CBadge v-else-if="item.purpose == 'guarantee'" color="warning" class="mr-1">
                  {{ $helper.stockPurposeLabel(item.inventoryType, item.purpose) }}
                </CBadge>
                <span v-else>-</span>
              </td>
            </template>
            <template #customer="{ item }">
              <td>
                <span v-if="item.customerName">
                  {{ item.customerCode ? item.customerCode + ' - ' : '' }}{{ item.customerName }}
                </span>
                <span v-else>-</span>
              </td>
            </template>
            <template #state="{ item }">
              <td>
                <!-- {{ item.state }} -->
                <CBadge v-if="item.state == 'draft'" color="secondary" class="mr-1">Nháp</CBadge>
                <CBadge v-if="item.state == 'done'" color="success" class="mr-1">Hoàn thành</CBadge>
              </td>
            </template>
            <template #action="{ item }">
              <td class="action-btn-group">
                <div class="action-btn-wrapper">
                  <CButton color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'" square size="sm"
                    @click="$router.push(`/stock-management/${item.id}/update.html`)">
                    <CIcon name="cil-pencil" />
                  </CButton>
                  <CButton color="danger" v-if="item.state == 'draft'" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Xóa'" @click="
                    setupSelectOneAction('delete_one', item.id, item.documentNo)
                    ">
                    <CIcon name="cil-trash" />
                  </CButton>
                  <CButton color="warning" v-if="item.state == 'done'" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Trả về nháp'" @click="
                    setupSelectOneAction('revert_draft', item.id, item.documentNo)
                    ">
                    <i class="fa fa-undo"></i>
                  </CButton>
                  <CButton color="info" v-if="item.state == 'done'" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Xuất báo cáo'" @click="
                    exportReport(item.id)
                    ">
                    <i class="fa fa-download"></i>
                  </CButton>
                </div>
              </td>
            </template>
          </BaseTable>
        </CCardBody>
      </CCard>

      <BaseExportModal v-if="isShowExportReport" :id="actionData.model.id" :uri="'/stock/export'"
            @close-modal="closeExportReport($event)"></BaseExportModal>

      <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    </div>
  </template>
  
  <script>
  import BaseTable from "../base/BaseDataTable";
  import ModalConfirm from "../base/BaseModalConfirm";
  import BaseInput from "../base/BaseInput";
  import BaseSwitch from "@/views/base/BaseSwitch";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseExportModal  from "../base/BaseExportModal";
  
  export default {
    name: "StockList",
    components: {
      BaseSwitch,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      BaseExportModal
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success"
      },
      showErrorMsg: {
        type: "error",
        title: "Error"
      },
      showWarningMsg: {
        type: "warn",
        title: "warn"
      }
    },
    data() {
      let that = this;
      let actionTypeMapping = new Map();

      actionTypeMapping.set("delete_one", {
        url: "/stock/delete",
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "xóa",
            "phiếu",
            that.actionData.model.documentNo
          );
        },
        isJsonContentType: false,
        // type: 'PUT',
        dataSubmit: function () {
          return { id: that.actionData.model.id };
        },
        successCallback: function () {
          that.actionData.model.listSelectedId = [];
          that.showSuccessMsg({ message: "Xóa phiếu " + that.actionData.model.documentNo + " thành công" });
          that.loadDataMainTable();
        }
      });
  
      actionTypeMapping.set("revert_draft", {
        url: "/stock/revert-draft",
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "trả về nháp",
            "phiếu",
            that.actionData.model.documentNo
          );
        },
        isShowWarningContent: true,
        warningContentPopup: function () {
          return "Phiếu hoàn thành sẽ chuyển về nháp và không còn được tính vào tồn kho. ";
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return { id: that.actionData.model.id };
        },
        successCallback: function () {
          that.showSuccessMsg({ message: "Đã trả phiếu " + that.actionData.model.documentNo + " về nháp" });
          that.loadDataMainTable();
        }
      });

      actionTypeMapping.set("delete_list", {
        url: "/stock/delete-list",
        titlePopup: function () {
          return that.$helper.setupTitleAction("xóa", "các phiếu", "đã chọn");
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            lsId: that.actionData.model.listSelectedId
          };
        },
        successCallback: function () {
          that.actionData.model.listSelectedId = [];
          that.showSuccessMsg({ message: "Xóa danh sách phiếu thành công" });
          that.loadDataMainTable();
        },
      });
  
      return {
        labelIcon: {
          labelOn: '\u2713',
          labelOff: '\u2715'
        },
        isShowExportReport: false,
        actionData: {
          actionTypeMapping: actionTypeMapping,
          model: {
            selectedAll: false,
            documentNo: null,
            id: null,
            listSelectedId: []
          }
        },
        documentNoInput: {
          options: {
            placeholder: "Mã phiếu",
            label: 'Mã phiếu',
          },
          data: {
            name: "documentNo",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        descriptionInput: {
          options: {
            placeholder: "Ghi chú",
            label: 'Ghi chú'
          },
          data: {
            name: "description",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        inventoryTypeSelect: {
          options: {
            filter: false,
            label: "Loại phiếu",
            selectAllText: "Tất cả",
          },
          data: {
            name: "inventoryType",
            items: [
              { key: "in", value: "Nhập kho" },
              { key: "out", value: "Xuất kho" },
            ],
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        customerSelect: {
          options: {
            filter: true,
            label: "Khách hàng",
            selectAllText: "Tất cả",
            keyField: "value",
            valueField: "text",
          },
          data: {
            name: "customerId",
            items: [],
            model: null,
            source: {
              url: "/customer/list-customer",
              dataSubmit: function () {
                return {};
              },
              response: function (dataResponse) {
                that.customerSelect.data.items = dataResponse.data;
              },
            },
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        mainTable: {
          options: {
            fields: [
              { key: "checkbox", label: "#", sorter: false, filter: false },
              { key: "createDate", label: "Ngày tạo"},
              { key: "warehouse", label: "Kho" },
              { key: "documentNo", label: "Mã phiếu" },
              { key: "inventoryType", label: "Loại phiếu" },
              { key: "purpose", label: "Phân loại" },
              { key: "customer", label: "Khách hàng" },
              { key: "inventoryDate", label: "Ngày chứng từ"},
              { key: "state", label: "Trạng thái"},
              { key: "accountingDate", label: "Ngày hoàn thành" },
              { key: "description", label: "Ghi chú" },
              { key: "action", label: "Thao tác", sorter: false, filter: false }
            ],
            slots: ["checkbox", "createDate", "inventoryDate", "inventoryType", "purpose", "accountingDate", "state", "warehouse", "customer", "action"],
            sorter: true,
            columnFilter: false,
            clickableRows: true,
            hover: false,
            itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
            pageSize: 20,
          },
          dataSource: {
            url: "/stock/getPages",
            dataSubmit: function () {
              that.actionData.model.listSelectedId = [];
              return that.$helper.setupDataSubmit(that.$data);
            },
            response: function (dataResponse) {
              return dataResponse.data;
            }
          }
        }
      };
    },
    methods: {
      rowClickTable(value) {
        let targetClick = value.event.target;
        if (value.column === 'action' && ($(targetClick).is("i.fa")) ||
          $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
          return;
        }
        if (value && value.item && value.item.id) {
          if (this.actionData.model.listSelectedId.includes(value.item.id)) {
            const index = this.actionData.model.listSelectedId.indexOf(value.item.id)
            if (index > -1) { // only splice array when item is found
              this.actionData.model.listSelectedId.splice(index, 1); // 2nd parameter means remove one item only
              value.item._classes = 'inactive';
            }
          } else {
            value.item._classes = 'active';
            this.actionData.model.listSelectedId.push(value.item.id);
          }
        }
      },
      loadDataMainTable: function (isUpdateFilter) {
        this.$refs.mainTable.loadData(true, isUpdateFilter);
      },
      changeSelectAll: function (event) {
        // let listSelectedId = this.actionData.model.listSelectedId;
        if (this.actionData.model.selectedAll) {
          this.actionData.model.listSelectedId = [];
  
          this.$refs.mainTable.items.forEach(each => {
            this.actionData.model.listSelectedId.push(each.id);
          });
        } else {
          this.actionData.model.listSelectedId = [];
        }
      },
      setupSelectOneAction: function (actionTypeKey, id, documentNo) {
        let actionData = this.actionData.model;
        actionData.documentNo = documentNo || null;
        actionData.id = id || null;
        this.$refs.actionModal.setCurrAction(actionTypeKey);
      },
      exportReport(id) {
        this.actionData.model.id = id || null;
        this.isShowExportReport = true;
      },
      closeExportReport(event) {
        this.isShowExportReport = false;
      }
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
      "actionData.model.listSelectedId": function (newValue) {
        let that = this;
        if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
          that.actionData.model.selectedAll = true;
          that.$refs.mainTable.items.map(each => each._classes = 'active');
        } else {
          that.actionData.model.selectedAll = false;
          if (newValue.length == 0) {
            that.$refs.mainTable.items.map(each => each._classes = 'inactive');
          }
        }
      }
    },
    computed: {}
  };
  </script>
  <style scoped>
  .td-roles {
    max-width: 250px;
  }
  
  </style>
  